// src/components/Modals/SupportModal.js
import React, { useState, useEffect, useContext } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { AuthContext } from '../../context/AuthContext';

const SupportModal = ({ onClose }) => {
  const { currentUser } = useContext(AuthContext);
  const [visible, setVisible] = useState(false);
  const [category, setCategory] = useState('Technical Issue');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [sending, setSending] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose(), 600);
  };

  const handleSend = async () => {
    if (!title || !description) {
      alert('Please fill in all required fields.');
      return;
    }
    if (!captchaToken) {
      setShowCaptcha(true);
      return;
    }
    setSending(true);
    try {
      const res = await fetch('/api/support/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          category, 
          title, 
          description, 
          captchaToken, 
          userId: currentUser ? currentUser._id : null 
        })
      });
      const data = await res.json();
      if (data.success) {
        alert('Your support request has been sent.');
        handleClose();
      } else {
        alert('There was an error sending your request. Please try again later.');
      }
    } catch (error) {
      console.error('Error sending support request:', error);
      alert('Error sending support request.');
    }
    setSending(false);
    setCaptchaToken('');
    setShowCaptcha(false);
  };

  return (
    <div className={`modal ${visible ? 'show' : ''}`} onClick={handleClose}>
      <div className="card modal-card" onClick={(e) => e.stopPropagation()}>
        <span className="close-modal" onClick={handleClose}>
          <img src="/images/i_modal_close.svg" alt="Close" />
        </span>
        <div className="form-group">
          <label className="text-uppercase">Issue Category</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value=""></option>
            <option value="Technical Issue">Technical Issue</option>
            <option value="Billing Issue">Billing Issue</option>
            <option value="Account Issue">Account Issue</option>
            <option value="Feature Request">Feature Request</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="form-group margin-top-l">
          <label className="text-uppercase">Title</label>
          <input 
            type="text" 
            value={title} 
            onChange={(e) => setTitle(e.target.value)} 
          />
        </div>
        <div className="form-group margin-top-l">
          <label className="text-uppercase">Description</label>
          <textarea 
            value={description} 
            onChange={(e) => setDescription(e.target.value)} 
          />
        </div>
        <div className="modal-actions margin-top-l text-right">
          <button onClick={handleSend} disabled={sending}>
            {sending ? 'Sending...' : 'Send'}
          </button>
        </div>
        {showCaptcha && (
          <div className="captcha-container" style={{ marginTop: '20px', textAlign: 'center' }}>
            <ReCAPTCHA
              sitekey="6LdxUQMrAAAAANxwtKp9HvRgeX6baY2ejAy53S_y"
              onChange={(token) => {
                setCaptchaToken(token);
                handleSend();
              }}
              onExpired={() => setCaptchaToken('')}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SupportModal;
